import { 
    GET_GUEST_SEARCH_FAILURE, 
    GET_GUEST_SEARCH_REQUEST, 
    GET_GUEST_SEARCH_SUCCESS 
  } from "../../../Utils/Constant";
  
  const initialState = {
    guestSearch: {},
    loading: false,
    error: null,
  };
  
  export const guestDetailReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_GUEST_SEARCH_REQUEST:
        return {
          ...state,
          loading: true,
          error: null, 
        };
      case GET_GUEST_SEARCH_SUCCESS:
        return {
          ...state,
          guestSearch: action.payload.data,
          loading: false,
          error: null,
        };
      case GET_GUEST_SEARCH_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };